import * as React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { columnFlex } from "../../../../components/layout";
import { Container } from "../components";

const StyledContainer = styled(Container)`
  ${columnFlex};
  align-items: center;
  text-align: center;
  margin-top: 3em;
`;

export function ParticipationClosedPage() {
  const { t } = useTranslation("token-onboarding");
  return (
    <StyledContainer>
      <h1 className="h1">{t("we-are-sorry-this-onboarding-form-is-closed")}</h1>
    </StyledContainer>
  );
}
